import { MessageResponseDto } from "@api/api";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { tierLevelFormDefault } from "@factory/form/form.default";
import { TierLevelFormRule, TierLevelFormSchema } from "@factory/form/form.rule";
import { useQyCreateTierLevel } from "@factory/query/tier-level.query";
import { useFormApiMapper } from "@factory/services/form-api-mapper.hook";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import { FieldErrors, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

export function useNewTierLevel() {
 // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateTierLevel } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New TierLevel is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addTierLevel, isLoading: isCreating } =
    useQyCreateTierLevel(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<TierLevelFormSchema>({
    defaultValues: tierLevelFormDefault,
    resolver: zodResolver(TierLevelFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: TierLevelFormSchema) => {
    const formData = mapCreateTierLevel(form);
    addTierLevel(formData);
  };
  const handleValidateError = (err: FieldErrors<TierLevelFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  };
}
